import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	Optional,
	Input,
	AfterViewInit,
	ElementRef
} from "@angular/core";
// import { SwiperConfigInterface } from "@sonrisa-dev/ngx-swiper-wrapper-sonfork";
import { CtaToggleButtonComponent } from "../cta-toggle-button/cta-toggle-button.component";
import { CtaToggleButtonGroupControlComponent } from "../cta-toggle-button-group-control/cta-toggle-button-group-control.component";

@Component({
    selector: "dodo-cta-toggle-button-group",
    templateUrl: "./cta-toggle-button-group.component.html",
    styleUrls: ["./cta-toggle-button-group.component.scss"],
    standalone: false
})
export class CtaToggleButtonGroupComponent implements OnInit, AfterViewInit {
	@Input() showPointer = false;
	@Input() showSwiper: boolean;
	@Input() title: string;
	@Input() hidePointer = false;

	_buttons: CtaToggleButtonComponent[] = [];

	_pointerPosition = -1;
	_totalStops = 0;

	// public config: SwiperConfigInterface = {
	// 	observer: true,
	// 	direction: "horizontal",
	// 	threshold: 0,
	// 	slidesPerView: 2,
	// 	keyboard: true,
	// 	mousewheel: true,
	// 	scrollbar: false,
	// 	navigation: true,
	// 	pagination: false,
	// 	slidesOffsetBefore: 200
	// };

	set activeButtonId(id: string | number) {
		if (this.__activeButtonId !== id) {
			this.__activeButtonId = id;

			if (this._buttons) {
				this.__updateButtonStatus();
			}
		}
	}

	public __activeButtonId: string | number;

	@Output() buttonClicked = new EventEmitter<string | number>();

	constructor(
		private __er: ElementRef,
		@Optional()
		private __buttonsGroupControl: CtaToggleButtonGroupControlComponent
	) {}

	ngOnInit() {
		if (this.__buttonsGroupControl) {
			this.__buttonsGroupControl.registerButtonGroup(this);
		}
	}

	addButton(button: CtaToggleButtonComponent) {
		button.clicked.subscribe((id: string | number) => {
			this.activeButtonId = id;
			this.buttonClicked.emit(this.__activeButtonId);
		});

		button.__active = button.id === this.__activeButtonId;
		this._buttons.push(button);
	}

	removeButton(button: CtaToggleButtonComponent) {
		const buttonIndex = this._buttons.map(b => b.id).indexOf(button.id);
		this._buttons.splice(buttonIndex, 1);
		if (button.id === this.__activeButtonId) {
			this.__resetActiveButton();
		}
	}

	private __resetActiveButton() {
		this.__activeButtonId = undefined;
	}

	private __updateButtonStatus() {
		this._buttons.forEach(
			b => (b.__active = b.id === this.__activeButtonId)
		);
	}

	ngAfterViewInit() {
		setTimeout(() => {
			const width = this.__er.nativeElement.offsetWidth;
			const beforeOffSet = width / 4;
			// this.config["slidesOffsetBefore"] = beforeOffSet;
			// this.config["slidesOffsetAfter"] = beforeOffSet;
		});
	}
}
